// 国际化简体中文配置
const zh_cn = {
  // 布局大小
  size: {
    default: "默认",
    large: "最大",
    small: "最小",
  },
  // 语言
  language:{
    english: "English",
    chinese: "简体中文",
  }
};
export default zh_cn;
